import { createEvent, createStore } from 'effector';
import { $resetAuth } from './profile-entity';

export interface IFeatures {
	builderEnabled: boolean;
	domainsEnabled: boolean;
	landingsEnabled: boolean;
	senderEnabled: boolean;
	senderWebappEnabled: boolean;
	senderHubProfileSettingsVisible: boolean;
	senderHubAuthJobsVisible: boolean;
	senderPresetsEnabled: boolean;
	senderAutoCampaignEnabled: boolean;
	senderConsoleEnabled: boolean;
}

export const $setFeatures = createEvent<IFeatures>();
export const $updateFeatures = createEvent<Partial<IFeatures>>();

export const $features = createStore<IFeatures>({
	builderEnabled: true,
	domainsEnabled: false,
	landingsEnabled: false,
	senderEnabled: false,
	senderWebappEnabled: false,
	senderHubProfileSettingsVisible: true,
	senderHubAuthJobsVisible: true,
	senderPresetsEnabled: true,
	senderAutoCampaignEnabled: true,
	senderConsoleEnabled: true,
})
	.on($setFeatures, (_, payload) => payload)
	.on($updateFeatures, (state, payload) => ({ ...state, ...payload }))
	.reset($resetAuth);
